import { cn } from "@/lib/utils";

export function BrandMark({ className }: { className?: string }) {
  return (
    <img
      src="/brand/scp-mark.svg?v=20261011"
      alt="SCP"
      width={64}
      height={64}
      className={cn("scp-brand-mark", className)}
    />
  );
}
